<template>
  <div>
    <!-- 卡片组件 -->
    <CardBox>
      <div slot="card_title" class="home_tit">
        <div>{{$t('main.text687')}}</div>

        <div>
          <!-- <el-button v-if="can_apply==1" @click="$router.push('/apply_card_input')" class="export_btn border_set_color2" size="medium">
            {{$t('main.bt2')}}
          </el-button> -->

          <el-button class="export_btn border_set_color2" size="medium" @click="$router.push('/kycManage')">
            {{$t('bank_card.KYC_Management')}}
          </el-button>

          <el-button class="export_btn border_set_color2" size="medium" @click="go_list">
            {{$t('main.text580')}}
          </el-button>
        </div>
        
      </div>
    </CardBox>

    <!-- 通过 弹框 -->
    <el-dialog
      :visible.sync="card_reason_ok_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px">
      <div class="log_out1">
          <img style="width:35px;" src="../../assets/img/Pigeon_icon.png" alt="">
      </div>
      <div class="log_out2 padding1">
        {{$t('main.text590')}}
      </div>
      <div class="log_out3 padding2">
        {{$t('main.text591')}}
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" class="confirm_btn2" @click="card_reason_ok_dlg=false">{{$t('main.text266')}}</el-button>
      </span>
    </el-dialog>

    <!-- 拒绝 弹框 -->
    <el-dialog
      :title="$t('main.text594')"
      :visible.sync="card_reason_no_dlg"
      custom-class="dlg element_input add_dlg"
      append-to-body
      width="480px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <div class="top_text">{{$t('main.text595')}}</div>
            <el-form-item>
              <el-input type="textarea" v-model="card_reason" :placeholder="$t('main.text596')"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="card_reason_no_dlg = false" class="cancel_btn border_set_color2">
            {{$t('main.text7')}}
        </el-button>
        <el-button type="primary" @click="no_btn" class="confirm_btn confirm_btn_bgc">
            {{$t('main.text597')}}
        </el-button>
      </span>
    </el-dialog>

    <!-- 激活 填信息 弹框 -->
    <el-dialog
      :title="$t('main.text627')"
      :visible.sync="card_activate_dlg"
      custom-class="dlg element_input add_dlg"
      append-to-body
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <div class="top_text">{{$t('main.text628')}}</div>
            <el-form-item :label="$t('main.text629')">
              <el-input v-model="card_digits"></el-input>
            </el-form-item>
            <el-form-item :label="$t('main.text630')">
              <el-input v-model="card_id"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="card_activate_dlg = false" class="cancel_btn border_set_color2">
            {{$t('main.text7')}}
        </el-button>
        <el-button type="primary" @click="card_activate_submit" class="confirm_btn">
            {{$t('main.text597')}}
        </el-button>
      </span>
    </el-dialog>

    <!-- 激活成功 弹框 -->
    <el-dialog
      :visible.sync="card_activate_ok_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px">
      <div class="log_out1">
          <img style="width:35px;" src="../../assets/img/Pigeon_icon.png" alt="">
      </div>
      <div class="log_out2 padding1">
        {{$t('main.text631')}}
      </div>
      <div class="log_out3 padding2">
        {{$t('main.text632')}}
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" class="confirm_btn2" @click="card_activate_ok_dlg=false">{{$t('main.text266')}}</el-button>
      </span>
    </el-dialog>

    <!-- 第一次充值信息 弹框 -->
    <el-dialog
      :title="$t('main.text633')"
      :visible.sync="first_top_up_dlg"
      custom-class="dlg element_input add_dlg"
      append-to-body
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <div class="top_text2">{{$t('main.text634')}}</div>
            <!-- 年费，卡费，激活卡的费用 如果扣除过了就不需要展示了
            手续费是每次都会展示的
            最大最小充值也需要都展示吧 -->
            <div class="info_1" v-if="top_up_config.annual_fee_status==0 ">
              <div class="info_1_left">{{$t('main.text503')}}</div>
              <div class="info_1_right">{{top_up_config.annual_fee}}</div>
            </div>
            <div class="info_1" v-if="top_up_config.card_cost_status==0 ">
              <div class="info_1_left">{{$t('main.text504')}}</div>
              <div class="info_1_right">{{top_up_config.card_cost}}</div>
            </div>
            <!-- 激活卡的费用 -->
            <div class="info_1" v-if="top_up_config.card_activation_status==0 ">
              <div class="info_1_left">{{$t('main.text644')}}</div>
              <div class="info_1_right">{{top_up_config.card_activation}}</div>
            </div>
            <!-- 手续费 -->
            <div class="info_1">
              <div class="info_1_left">{{$t('main.text645')}}</div>
              <div class="info_1_right">{{top_up_config.load_fee}}</div>
            </div>
            <div class="info_1">
              <div class="info_1_left">{{$t('main.text635')}}</div>
              <div class="info_1_right">{{top_up_config.min_top_up}}</div>
            </div>
            <div class="info_1">
              <div class="info_1_left">{{$t('main.text636')}}</div>
              <div class="info_1_right">{{top_up_config.max_top_up}}</div>
            </div>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="first_top_up_dlg = false" class="cancel_btn border_set_color2">
            {{$t('main.text7')}}
        </el-button>
        <el-button type="primary" @click="first_top_up_next" class="confirm_btn">
            {{$t('main.text394')}}
        </el-button>
      </span>
    </el-dialog>

    <!-- 充值 弹框 -->
    <el-dialog
      :title="$t('main.text626')"
      :visible.sync="top_up_dlg"
      custom-class="dlg element_input add_dlg"
      append-to-body
      width="640px"
    >
      <div class="dlg_body">
        <div class="d_body">
          <el-form class="dlg_form dlg_form2" label-position="top">
            <div class="top_text2">{{$t('main.text637')}}</div>
            <div class="top_text3">{{$t('main.text638')}}</div>
            <div class="amount_box">
              <div class="top_text4">{{$t('main.text389')}}</div>
              <div class="top_text5">{{$t('main.text650')}}{{top_up_config.min_top_up}}{{$t('main.text651')}}{{top_up_config.max_top_up}}</div>
              <div class="zdy_input box_margin">
                <el-input v-model="input_v3_set"
                  placeholder=""
                  @input="input3_set"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d{8}).*$/, '$1$2.$3').replace(/^\./g, '')"
                  ></el-input>
                  <el-popover
                    width="170"
                    popper-class="bz_pop"
                    v-model="visible3"
                    trigger="click">
                    <div slot="reference" class="type_box">
                      <div class="type_box1">
                        <img :src="set_name_img(select3)" alt="">
                        <div class="type_box2">{{select3}}</div>
                      </div>
                      <div class="type_box3"><i class="el-icon-caret-bottom"></i></div>
                    </div>
                    <div class="bz_list">
                      <!-- 加密货币 BTC ETH USDT-ERC20 USDT-TRC20 USDT-BSC20 USDC-ERC20 USDC-TRC20 USDC-BSC20 -->
                      <div class="type_box1 bz_list1" v-for="(item,index) in currency_list3" :key="index" @click="select3_fun(item)">
                        <img :src="set_name_img(item)" alt="">
                        <div class="type_box2">{{item}}</div>
                      </div>
                    </div>
                  </el-popover>
              </div>
              <div class="top_text5">{{$t('main.text652')}}
                <span class="top_text10" v-if="select3== 'BTC' ">BTC = {{top_up_details.btc_balance}}</span>
                <span class="top_text10" v-else-if="select3== 'ETH' ">ETH = {{top_up_details.eth_balance}}</span>
                <span class="top_text10" v-else-if="select3== 'USDT' ">USDT = {{top_up_details.usdt_balance}}</span>
                <span class="top_text10" v-else-if="select3== 'USDC' ">USDC = {{top_up_details.usdc_balance}}</span>
              </div>
              <!-- 充值数量超过充值限额 警示框 红色 -->
              <div class="warning_red" v-show="warning_red_show">
                <div class="warning_red_icon"><i class="el-icon-warning"></i></div>
                <div class="warning_red_text">{{$t('main.text653')}}{{top_up_config.max_top_up}}{{$t('main.text654')}}</div>
              </div>
              <!-- 余额不足  警示框 黄色 -->
              <div class="warning_red warning_yellow" v-show="warning_yellow_show">
                <div class="warning_red_icon warning_yellow_icon"><i class="el-icon-warning"></i></div>
                <div class="warning_red_text warning_yellow_text">
                  {{$t('main.text655')}}
                  <div>
                    <router-link :to="{ path: '/blockchain_d/deposit' }" class="top_up_link">{{$t('main.text656')}}</router-link>
                  </div>
                </div>
              </div>

              <div class="top_text4 top_text6" v-show="usdt_num_show">{{$t('main.text657')}}</div>
              <div class="top_text7" v-show="usdt_num_show">USD {{usdt_num*1}}</div>
            </div>
            <div>
              <div class="top_text4 top_text6">{{$t('main.text514')}}</div>
              <div class="top_text8">
                <div class="top_text9">{{$t('main.text567')}}</div>
                <div class="top_text10">{{top_up_details.card_name}}</div>
              </div>
              <div class="top_text8">
                <div class="top_text9">{{$t('main.text658')}}</div>
                <div class="top_text10">{{top_up_details.number}}</div>
              </div>
              <div class="top_text8">
                <div class="top_text9">{{$t('main.text255')}}<br/>({{$t('main.text659')}} = {{top_up_details.card_limit}})</div>
                <div class="top_text10">USD {{top_up_details.balance}}</div>
              </div>
            </div>

          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="top_up_dlg = false" class="cancel_btn border_set_color2">
            {{$t('main.text7')}}
        </el-button>
        <el-button type="primary" @click="top_up_submit" class="confirm_btn">
            {{$t('main.text36')}}
        </el-button>
      </span>
    </el-dialog>

    <!-- 充值成功 弹框 -->
    <el-dialog
      :visible.sync="top_up_success_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px">
      <div class="log_out1">
          <img style="width:35px;" src="../../assets/img/Pigeon_icon.png" alt="">
      </div>
      <div class="log_out2 padding1">
        {{$t('main.text639')}}
      </div>
      <div class="log_out3 padding2">
        {{$t('main.text640')}}
        {{usdt_num}}
        {{$t('main.text640_r')}}
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" class="confirm_btn2" @click="top_up_success_dlg=false">{{$t('main.text266')}}</el-button>
      </span>
    </el-dialog>

    <!-- 充值失败 弹框 -->
    <el-dialog
      :visible.sync="top_up_error_dlg"
      custom-class="log_out_dlg_bgc"
      append-to-body
      center
      :show-close="false"
      width="480px">
      <div class="log_out1">
          <img style="width:35px;" src="../../assets/img/error_icon.png" alt="">
      </div>
      <div class="log_out2 padding1">
        {{$t('main.text641')}}
      </div>
      <div class="log_out3 padding2">
        {{$t('main.text642')}}
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" class="reset_btn" @click="top_up_error_dlg=false">{{$t('main.text7')}}</el-button>
          <el-button type="primary" class="apply_btn" @click="card_topUp_fun">{{$t('main.text643')}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { home,card_audit,card_getTopUpConfig,card_active,card_topUp } from "@/api/api";
import CardBox from '../../component/card';
import BigNumber from 'bignumber.js';

export default {
  components:{
      CardBox
  },
  data() {
    return {
      currentPage: 1,
      page: 1, //分页 从 1 开始
      limit: 10, //每页条数
      page_total: 0, //一共多少条
      tableData: [],
      card_reason_ok_dlg:false,
      card_reason_no_dlg:false,
      card_reason:'',
      card_reason_no_id:"",

      form:{
        content:"",
        time:'',
        status:''
      },
      card_activate_dlg:false,
      card_digits:'',
      card_id:'',
      card_activate_ok_dlg:false,
      first_top_up_dlg:false,
      top_up_dlg:false,
      
      visible3:false,
      select3:'BTC',
      input_v3:'',
      input_v3_set:'',
      inp3_ratio:'',

      currency_list3:["BTC","ETH","USDT","USDC"],

      // 币种 图标
      icon_list:{
        ETH:require("../../assets/img/ETH.png"),
        USDT:require("../../assets/img/USDT.png"),
        BTC:require("../../assets/img/BTC.png"),
        USDC:require("../../assets/img/USDC.png"),
        USD:require("../../assets/img/USD.png"),
        CNY:require("../../assets/img/CNY.png"),
        SGD:require("../../assets/img/SGD.png"),
        GBP:require("../../assets/img/GBP.png"),
        AUD:require("../../assets/img/AUD.png"),
        HKD:require("../../assets/img/HKD.png"),
      },
      top_up_success_dlg:false,
      top_up_error_dlg:false,
      top_up_config:"",
      top_up_id:"",
      activate_card_id:'',
      top_up_details:'',
      rateConfig:"",
      usdt_num:"",
      usdt_num_show:false,
      account_num:"",
      warning_red_show:false,
      warning_yellow_show:false,
      can_apply:0,//can_apply: 是否可以继续申请卡 1是 0 不是

    };
  },
  beforeDestroy() {
    sessionStorage.removeItem("top_title_name");
  },
  mounted() {
    sessionStorage.setItem("top_title_name", this.$t('main.text512'));
    this.get_list();
  },
  methods: {
    get_list() {
      home().then((res) => {
        if (res.data.code == 200) {
          this.can_apply = res.data.data.can_apply;
          
        }
      });
    },
    current_change(v){
      this.page=v;
      this.limit=10;
      this.get_list();
    },
    go_list(){
      this.$router.push("/top_up_history");
    },
    row_bgc({row}){
      
      if(row.method==2){
        return "row_2_bgc";
      }
    },
    set_number_4(v){
      if (v) {
        let str1=str1.substr(-4);
        return "•••• •••• ••••"+str1;
      }else{
        return '-';
      }
    },
    to_info(id){
      this.$router.push({path:'/apply_card_info',query:{cards_id:id}});
    },
    // 通过
    card_reason_ok_fun(id){
      card_audit({
        id:id,
        status:1
      }).then((res) => {
        if (res.data.code == 200) {
          this.card_reason_ok_dlg=true;
          this.get_list();
        }else{
          this.message.ismessage('error',res.data.msg);
        }
      });

    },
    // 拒绝
    card_reason_no_fun(id){
      this.card_reason_no_dlg=true;
      this.card_reason_no_id=id;
      
    },
    // 拒绝 弹框 确定按钮
    no_btn(){
      if(!this.card_reason){
        return this.message.ismessage('error',this.$t('main.text598'));
      }
      
      let r_ch="";
      let r_en="";
      let r_jp="";
      if(this.v_lan=='ch'){
        r_ch=this.card_reason;
        r_en="";
        r_jp="";
      }else if(this.v_lan=='jp'){
        r_ch="";
        r_en="";
        r_jp=this.card_reason;
      }else{
        r_ch="";
        r_en=this.card_reason;
        r_jp="";
      }

      card_audit({
        id:this.card_reason_no_id,
        status:0,
        reason_ch:r_ch,
        reason_en:r_en,
        reason_jp:r_jp
      }).then((res) => {
        if (res.data.code == 200) {
          this.message.ismessage('success',res.data.msg);
          this.card_reason_no_dlg=false;
          this.get_list();
        }else{
          this.message.ismessage('error',res.data.msg);
        }
      });
    },

    reset_btn(){
      this.form.time='';
      this.form.content="";
      this.form.status='';
      this.page=1;
      this.limit=10;
      this.currentPage=1;
      this.get_list();
    },
    apply_btn(){
      
      this.page=1;
      this.limit=10;
      this.currentPage=1;
      this.get_list();
    },
    activate_btn(id){
      this.card_digits="";
      this.card_id="";
      this.card_activate_dlg=true;
      this.activate_card_id=id;
      
    },
    card_activate_submit(){
      if(!this.card_digits.trim()||this.card_digits.length !== 16){
        return this.message.ismessage('error',this.$t('main.text660'));
      }
      if(!this.card_id.trim()){
        return this.message.ismessage('error',this.$t('main.text661'));
      }
      card_active({
        id:this.activate_card_id,
        number:this.card_digits,
        card_id:this.card_id
      }).then(res=>{
        if(res.data.code==200){
          this.message.ismessage('success',res.data.msg);
          this.card_activate_dlg=false;
          this.card_activate_ok_dlg=true;
        }else{
          this.message.ismessage('error',res.data.msg);
        }
      })

      
    },
    top_up_btn(id){
      this.first_top_up_dlg=true;
      this.top_up_id=id;
      this.get_top_up_config(id);
    },
    first_top_up_next(){
      this.first_top_up_dlg=false;
      this.top_up_dlg=true;
      this.input_v3="";
      this.input_v3_set="";
      this.usdt_num_show=false;
      this.warning_red_show=false;
      this.warning_yellow_show=false;

    },
    top_up_submit(){
      if(!this.input_v3.trim()){
        return this.message.ismessage('error',this.$t('main.text389'));
      }
      if (this.usdt_num <= this.account_num) {
        return this.message.ismessage('error',this.$t('main.text662'));
      }
      
      if((this.input_v3)*1 > ((this.top_up_config.max_top_up).substr(1))*1){
        return this.warning_red_show=true;
      }else{
        this.warning_red_show=false;
      }

      
      if(this.select3=="BTC"){
        if((this.input_v3)*1 > this.top_up_details.btc_balance){
          return this.warning_yellow_show=true;
        }else{
          this.warning_yellow_show=false;
        }
      }else if(this.select3=="ETH"){
        if((this.input_v3)*1 > (this.top_up_details.eth_balance)*1){
          return this.warning_yellow_show=true;
        }else{
          this.warning_yellow_show=false;
        }
      }else if(this.select3=="USDT"){
        if((this.input_v3)*1 > (this.top_up_details.usdt_balance)*1){
          return this.warning_yellow_show=true;
        }else{
          this.warning_yellow_show=false;
        }
      }else if(this.select3=="USDC"){
        if((this.input_v3)*1 > (this.top_up_details.usdc_balance)*1){
          return this.warning_yellow_show=true;
        }else{
          this.warning_yellow_show=false;
        }
      }

      if (this.usdt_num < (this.top_up_config.min_top_up).substr(1)*1) {
        return this.message.ismessage('error',this.$t('main.text663'));
      }
      if (this.usdt_num > (this.top_up_config.max_top_up).substr(1)*1) {
        return this.message.ismessage('error',this.$t('main.text664'));
      }
      
      this.card_topUp_fun();
    },
    card_topUp_fun(){
      card_topUp({
        id:this.top_up_id,
        token_type:this.select3,
        amount:this.input_v3
      }).then(res=>{
        if(res.data.code==200){
          this.message.ismessage('success',res.data.msg);
          this.top_up_dlg=false;
          this.top_up_success_dlg=true;
        }else{
          this.message.ismessage('error',res.data.msg);
          this.top_up_error_dlg=true;
        }
      })
    },
    input3_set(v){
      this.input_v3=v;
      this.input_v3_set=this.set_num3_2(v);
      this.set_usd_num(v);
    },
    select3_fun(v){
      this.select3=v;
      this.visible3=false;
      if(this.input_v3){
        this.set_usd_num(v)
      }
    },
    set_name_img(v){
      if (v.indexOf('-')!= -1) {
        let str1=v.split('-')[0];
        return this.icon_list[str1];
      }else{
        return this.icon_list[v];
      }
    },
    // 设置key 对应接口 key
    set_api_key(v){
      if (v.indexOf('-')!= -1) {
        return v.toLowerCase().replace('-','_');
      }else{
        return v.toLowerCase();
      }
    },
    get_top_up_config(id){
      // 获取充值配置
      card_getTopUpConfig({id:id*1}).then(res=>{
        if (res.data.code == 200) {
          this.top_up_config = res.data.data;
          this.top_up_details = res.data.details;
          this.rateConfig = res.data.details.rateConfig;
          
        }
      })
    },
    // 计算 用户输入 转换usd
    set_usd_num(v){
      v;
      if(this.input_v3){
        this.usdt_num_show=true;
      }else{
        this.usdt_num_show=false;
      }
      if(this.select3){
        
        let rateConfig_key = this.select3+"USD";
        // 页面需要判断 token转化为的USD的数量必须大于 所有的手续费之和
        // 例如 USDT 100 USDTUSD = 10 则USD = 1000
        // let usdt_num = v * this.top_up_details[rateConfig_key];
        this.usdt_num = new BigNumber(this.input_v3).times(this.rateConfig[rateConfig_key]).toFixed(6,0);
        // console.log(this.usdt_num);
        
        // 在根据年费状态，卡费状态，激活卡费用状态 判断 是否扣除年费，卡费，激活卡的费用，
        // 年费 100， 卡费 50， 激活卡的费用 50 手续费比率 0.1
        
        let fee=0,fee2 = 0,fee3 = 0;
        if(this.top_up_config.annual_fee_status==0){
          fee=(this.top_up_config.annual_fee).substr(1)*1;
        }
        if(this.top_up_config.card_cost_status==0){
          fee2=(this.top_up_config.card_cost).substr(1)*1;
        }
        if(this.top_up_config.card_activation_status==0){
          fee3=(this.top_up_config.card_activation).substr(1)*1;
        }

        let z_fee = fee + fee2 + fee3;
        

        // 则扣除手续费的基数 // 则扣除手续费的基数 1000 - 100 - 50 - 50 = 800
        let num_js= new BigNumber(this.usdt_num).minus(z_fee).toFixed(6,0);
        
        // 手续费 800 * 0.1 = 80  // 2.25%  ->  0.0225
        let load_fee = (this.top_up_config.load_fee).slice(0,-1)/100;
        let fee_num = new BigNumber(num_js).times(load_fee).toFixed(6,0);
        
        // 实际到账 800 - 80 = 720
        this.account_num = new BigNumber(num_js).minus(fee_num).toFixed(2,0);
        // 需要判断 换算出来的USD 1000 必须大于 720
        
        
      }

    }


  },

};
</script>

<style scoped>
.t_h1_top{
  margin-top: 40px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 16px;
}
.t_h1_box{
  background: #232A36;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 28px;
  padding-bottom: 6px;
}
.zdy_form >>> .el-form-item{
  display: inline-block;
  width: 252px;
  margin-right: 20px;
}
.zdy_form >>> .el-date-editor.el-input,
.zdy_form >>> .el-select{
  width: 100%;
}
.zdy_form >>> .el-form-item:last-child{
  margin-right: 0;
}
.zdy_form >>> .el-form-item__label {
  padding: 0;
  line-height: inherit;
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.6);
}
.zdy_form >>> .el-input__inner{
  background: #333A47;
  border: none;
  border-radius: 8px;
  color: #fff;
}
.reset_btn,
.reset_btn:hover,
.reset_btn:active,
.reset_btn:focus{
  min-width: 140px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #BBBBBB;
  background: transparent;
  border: 1.25px solid #BBBBBB;
  border-radius: 4px;
}
.apply_btn,
.apply_btn:hover,
.apply_btn:active,
.apply_btn:focus{
  min-width: 140px;
  border-color: #00C18E;
  background: #00C18E;
  border-radius: 4px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  color: #191E29;
}
.zdy_form .btn_box{
  width: auto;
}
.t_h2_box{
  display: flex;
  justify-content: space-between;
  margin-top: 80px;
  align-items: center;
}
.t_h2_txt1{
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 4px;
}
.t_h2_txt2{
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.8);
}
.export_btn,
.export_btn:hover,
.export_btn:active,
.export_btn:focus{
  min-width: 136px;
  color: #00C18E;
  border-color: #00C18E;
  border-style:solid;
  border-width: 1.5px;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  min-width: 120px;
  background: transparent;
}
.icon_width{
  width: 20px;
  vertical-align: middle;
  cursor: pointer;
}
.color_red{
  color: #F35F65;
}
.zdy_tab_header >>> .el-table tr th:last-child, .zdy_tab_header >>> .el-table__body tr td:last-child{
  padding-left: 0 !important;
}
.btn_icon{
  width: 19px;
  vertical-align: middle;
  margin-right: 12px;
}
.tab_btn1{
  height: 32px;
  border: 1px solid #DEB981;
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #DEB981;
  background: transparent;
  margin-top: 5px;
}
.tab_btn2{
  height: 32px;
  border: 1px solid #FF4646;
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #FF4646;
  background: transparent;
  margin-top: 10px;
}
.top_text{
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #FFFFFF;
  margin-bottom: 20px;
  word-break: break-word;
}
.dlg_form >>> .el-textarea__inner {
  background: #223C58;
  border-color: #223C58;
  color: #fff;
  height: 100px;
}

.confirm_btn_bgc,
.confirm_btn_bgc:hover,
.confirm_btn_bgc:focus,
.confirm_btn_bgc:active{
  background: #F35F65;
  border-color: #F35F65;
  color: #fff;
}
/* ---08-16 新增 --- */
.top_text2{
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: #FFFFFF;
  margin-bottom: 10px;
  word-break: break-word;
}
.info_1{
  display: flex;
  border-bottom: 1px solid #314B69;
  box-sizing: border-box;
  padding: 20px 0;
}
.info_1_left{
  width: 60%;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
}
.info_1_right{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.6;
}
.top_text3{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.6;
}
.amount_box{
  box-sizing: border-box;
  padding: 20px 0;
  border-bottom: 1px solid #223C58;
}
.top_text4{
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  margin-bottom: 8px;
}
.top_text5{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.6;
}
/* -- 输入下拉 选择币种 */
.zdy_input >>> .el-input__inner{
  /* width: 224px; */
  height: 68px;
  background: #333A47;
  border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 8px 0px 0px 8px;
  display: inline-block;
  font-size: 24px;
  color: #fff;
}
.zdy_input >>> .el-input{
  width: 100%;
}
.zdy_input{
  display: flex;
}
.zdy_form >>> .el-form-item__label{
  line-height: inherit;
  padding: 0;
  padding-bottom: 8px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #fff;
}
.type_box{
  /* width: 154px; */
  width: 170px;
  height: 68px;
  border-radius: 0px 8px 8px 0px;
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #191E29;
}
.type_box1{
  display: flex;
  align-items: center;
  cursor: pointer;
}
.type_box1 img{
  width: 26px;
  vertical-align: middle;
  margin-right: 8px;
}
.type_box2{
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
}
.type_box3{
  color: rgba(255, 255, 255, 0.8);
}
.bz_list{
  box-sizing: border-box;
  padding: 8px;
}
.bz_list1{
  margin-bottom: 10px;
}
.bz_list .bz_list1:last-child{
  margin-bottom: 0;
}
.inp_btm_tit{
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 12px;
}
/* ----over---- */
.box_margin{
  box-sizing: border-box;
  padding: 8px 0 12px;
}
.top_text6{
  margin-top: 25px;
  margin-bottom: 8px;
}
.top_text7{
  padding: 18px 12px 20px;
  background: #041728;
  border-radius: 8px;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  color: #FFFFFF;
}
.top_text8{
  display: flex;
  margin-top: 12px;
}
.top_text8>div{
  width: 50%;
}
.top_text9{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #FFFFFF;
  opacity: 0.6;
}
.top_text10{
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  color: #FFFFFF;
}
.warning_red{
  background: #FEDFE0;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 12px 15px;
  display: flex;
  align-items: center;
  margin-top: 8px;
}
.warning_yellow{
  background: #E8DAC8;
}
.warning_red_icon i{
  color: #F35F65;
  font-size: 25px;
  margin-right: 12px;
}
.warning_red_text{
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: #F35F65;
}
.warning_yellow_icon i,
.warning_yellow_text{
  color: #B28247;
}
.top_up_link{
  color: #041728;
  text-decoration: underline;
}
.home_tit {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}



</style>

<style>
.cards_table .row_2_bgc,
.cards_table .row_2_bgc .el-table__cell{
  background: #172C43 !important;
}
.cards_table .row_2_bgc:hover{
  background: #172C43 !important;
}
.cards_table .el-table--striped .el-table__body .row_2_bgc ,
.cards_table .el-table--striped .el-table__body .row_2_bgc td.el-table__cell{
  background: #172C43 !important;
}
/* ------ */
.bz_pop{
  color: #fff;
  font-size: 15px;
  background: #191E29;
  box-shadow: 0px 0px 4px #191E29;
  /* border-radius: 16px; */
  border: none;
  box-sizing: border-box;
  transform: translateY(-10px);
}
.bz_pop .popper__arrow {
  display: none;
}
</style>

<style scoped>
@media screen and (max-width: 850px) {
  .t_h2_box {
    display: block;
    margin-top: 0;
    align-items: left;
  }
  .t_h1_top {
    margin-top: 0;
  }
  .t_h2_txt1 {
    margin-bottom: 10px;
    margin-top: 40px;
  }
  .home_tit{
    flex-direction: column;
    align-items: baseline;
  }

}
</style>
